import React, { useState } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Spinner } from "reactstrap";

import { loginWithGoogle } from "../../slices/auth/login/thunk";
import config from "../../config";

const GoogleSignInButton = ({ label = "Continue with Google" }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const disabled = !config.google.CLIENT_ID;

    const login = useGoogleLogin({
        flow: "implicit",
        scope: "openid email profile",
        onSuccess: async (tokenResponse) => {
            if (tokenResponse && tokenResponse.access_token) {
                await dispatch(loginWithGoogle(tokenResponse.access_token, navigate));
            }
            setLoading(false);
        },
        onError: () => setLoading(false),
        onNonOAuthError: () => setLoading(false),
    });

    if (disabled) {
        return (
            <div style={{
                padding: "10px 14px",
                fontSize: 12.5,
                color: "var(--ah-fg-dim)",
                border: "1px dashed var(--ah-border)",
                borderRadius: 8,
                textAlign: "center",
            }}>
                Google sign-in is disabled (no client ID configured).
            </div>
        );
    }

    return (
        <Button
            type="button"
            className="w-100"
            disabled={loading}
            onClick={() => { setLoading(true); login(); }}
            style={{
                background: "var(--ah-bg-elev-2)",
                color: "var(--ah-fg)",
                border: "1px solid var(--ah-border-strong)",
                fontWeight: 500,
                height: 44,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
                borderRadius: 8,
            }}
        >
            {loading
                ? <><Spinner size="sm" /> Signing in…</>
                : <>
                    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
                        <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z" />
                        <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.259c-.806.54-1.836.86-3.048.86-2.344 0-4.328-1.583-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z" />
                        <path fill="#FBBC05" d="M3.964 10.706A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.706V4.962H.957A8.997 8.997 0 0 0 0 9c0 1.452.348 2.827.957 4.038l3.007-2.332z" />
                        <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.962L3.964 7.294C4.672 5.166 6.656 3.58 9 3.58z" />
                    </svg>
                    {label}
                </>}
        </Button>
    );
};

export default GoogleSignInButton;
